module.exports = __webpack_public_path__ + "media/images/icons/chevron-67e4baf6df89ab904bb5235e10750128.svg";